var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicBroom = function SvgMagicBroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.806 15.754a1.15 1.15 0 0 1 .268 1.495l-1.929 3.906-3.906 1.929a1.153 1.153 0 0 1-1.5-.268L12.7 18.145a3.87 3.87 0 0 1 .286-5.153v0a3.87 3.87 0 0 1 5.152-.285zm-12.317-5.255L.761.749"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.04 14.528-1.551-1.529a1.768 1.768 0 0 1 2.5-2.5l1.562 1.54m5.088 9.86-3.15-3.15m5.684.325-3.434-2.575m-2.978-9.75h4.5m-2.25-2.25v4.5m-9-6.75h3m-1.5-1.5v3m-9.75 8.25h3m-1.5-1.5v3m5.25 8.25h3m-1.5-1.5v3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M21.038 2.249a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75M2.94 20.934a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m4.402-3.163a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgMagicBroom;